
import { useState } from 'react';
import { MessageCircle, X, Users, Bot, HelpCircle } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useLocation } from 'react-router-dom';

const WhatsAppButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const allOptions = [
    {
      icon: Bot,
      title: "DUOCORE Copy Trade",
      description: "Informações sobre sistema automatizado",
      message: "Olá! Tenho interesse no *DUOCORE Copy Trade* e gostaria de saber mais informações sobre realizar a contratação!"
    },
    {
      icon: Users,
      title: "Robôs Prontos",
      description: "Estratégias especializadas",
      message: "Olá! Tenho interesse nos *Robôs Prontos* e gostaria de saber mais informações sobre realizar a contratação!"
    }
  ];

  // Filter options based on current route
  const options = location.pathname === '/duocore' 
    ? allOptions.filter(option => option.title === "DUOCORE Copy Trade")
    : allOptions;

  const handleOptionClick = (message: string) => {
    const phoneNumber = "5511948621950"; // WhatsApp number without spaces or special characters
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setIsOpen(false);
  };

  return (
    <>
      {/* WhatsApp Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 bg-gradient-to-r from-cyan-400 to-green-400 hover:from-cyan-500 hover:to-green-500 text-slate-900 p-4 rounded-full shadow-lg hover:shadow-cyan-400/25 transition-all duration-300 group focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-900"
        aria-label={isOpen ? "Fechar menu WhatsApp" : "Abrir menu de contato WhatsApp"}
        aria-expanded={isOpen}
      >
        {isOpen ? (
          <X className="h-6 w-6 group-hover:scale-110 transition-transform duration-200" />
        ) : (
          <MessageCircle className="h-6 w-6 group-hover:scale-110 transition-transform duration-200" />
        )}
        
        {/* Pulse animation when closed */}
        {!isOpen && (
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-cyan-400 to-green-400 animate-ping opacity-30"></div>
        )}
      </button>

      {/* WhatsApp Modal */}
      {isOpen && (
        <div className="fixed bottom-24 right-6 z-40 animate-fade-in">
          <Card className="w-80 bg-slate-800/95 backdrop-blur-sm border-slate-700 shadow-2xl">
            <CardContent className="p-0">
              {/* Header */}
              <div className="bg-gradient-to-r from-cyan-400 to-green-400 p-4 rounded-t-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <MessageCircle className="h-5 w-5 text-slate-900" />
                  </div>
                  <div>
                    <h3 className="font-bold text-slate-900">Como podemos ajudar?</h3>
                    <p className="text-sm text-slate-700">Escolha uma opção abaixo</p>
                  </div>
                </div>
              </div>

              {/* Options */}
              <div className="p-4 space-y-3">
                {options.map((option, index) => (
                  <button
                    key={index}
                    onClick={() => handleOptionClick(option.message)}
                    className="w-full p-3 bg-slate-700/50 hover:bg-slate-700 rounded-lg transition-all duration-200 text-left group border border-slate-600 hover:border-cyan-400/50"
                  >
                    <div className="flex items-start space-x-3">
                      <div className="w-8 h-8 bg-gradient-to-r from-cyan-400/20 to-green-400/20 rounded-lg flex items-center justify-center group-hover:from-cyan-400/30 group-hover:to-green-400/30 transition-colors duration-200">
                        <option.icon className="h-4 w-4 text-cyan-400" />
                      </div>
                      <div className="flex-1">
                        <h4 className="font-medium text-white text-sm group-hover:text-cyan-400 transition-colors duration-200">
                          {option.title}
                        </h4>
                        <p className="text-xs text-slate-400 mt-1">
                          {option.description}
                        </p>
                      </div>
                    </div>
                  </button>
                ))}
              </div>

              {/* Footer */}
              <div className="p-4 border-t border-slate-700">
                <div className="flex items-center justify-center space-x-2 text-slate-400 text-xs">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span>Resposta rápida garantida</span>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 z-30 bg-black/20 backdrop-blur-sm animate-fade-in"
          onClick={() => setIsOpen(false)}
        />
      )}
    </>
  );
};

export default WhatsAppButton;
